import React from "react";

const Loader = () => {
  return (
    <div className="loader loader--show">
    <div className="loader__container">
      <div className="spinner"></div>
    </div>
    <div className="loader__backdrop"></div>
  </div>
  );
};

export default Loader;
